import React from 'react';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="container text-center">
                <p className="m-0">
                    © 2025 ZPlayer. All rights reserved.
                </p>
                <div className="footer-links">
                    <a href="/terms&conditions"target="_blank" className="footer-link">Terms & Conditions</a>
                    <span> | </span>
                    <a href="/abouts"target="_blank" className="footer-link">Privacy Policy</a>
                </div>
            </div>
        </footer>
    );
}
